// eslint-disable-next-line import/prefer-default-export
export const isAuthenticatedRoute = (route) =>
  route.matched.some((matchedRoute) => matchedRoute.meta.requiresAuth)
